import React, { useState } from 'react';
import SearchIcon from "@mui/icons-material/Search";
import SwapVert from "@mui/icons-material/SwapVert";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TextField,
    Link,
    Button,
    Dropdown,
    Menu,
    MoreOutlined,
} from '@mui/material';

import appColors from '../config/appColors';

const DataTable = ({ data, columns, searchColoumns }) => {

    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [dataTemp, setDataTemp] = useState(data);


    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        // let filterData = data.filter((item) => searchColoumns.some((coloumn) => item[coloumn].toLowerCase().includes(event.target.value.toLowerCase())));
        // setDataTemp(filterData);    

    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...data].sort((a, b) => {
        if (sortConfig.key !== null) {
            if (a[sortConfig.key] < b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
        }
        return 0;
    });

    const filteredData = sortedData.filter((item) =>
        Object.values(item).some(
            (value) => typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    return (
        <div style={{ width: "98%", }}>


            <div className="searchBar-Container" style={{ marginTop: 10, marginLeft: 0,display:'flex',flexDirection:'row',width:"50%",backgroundColor:'#ebe8e8ff',height:49,borderRadius:10,alignItems:'center',paddingRight:10,paddingLeft:10 }}  >
                <div style={{ width: 1.5, height: '15px', backgroundColor: appColors.primary, marginTop: 3 }} />
                <input
                    onChange={handleSearch}
                    placeholder="Search"
                    style={{ border: "none", fontFamily: 'Poppins', marginLeft: 5, outline: "none", width: "100%", height: "100%", backgroundColor: "transparent", fontSize: 13 }} />
                <SearchIcon style={{ color: appColors.primary, fontSize: 20 }} />
                
            </div>


            <TableContainer
                style={{ marginTop: 10 }}
                component={Paper}>
                <Table>
                    <TableHead style={{ backgroundColor: appColors.dataTableHeader }}>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    style={{ fontFamily: 'Poppins', fontSize: 14, color: 'black' }}
                                    key={column.key} onClick={() => handleSort(column.dataIndex)}>
                                    <div style={{ display: 'flex', flexDirection: 'row',alignItems:'center' }}>
                                        {column.title}
                                        <SwapVert style={{fontSize:15}} />
                                    </div>

                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData.map((row, index) => (
                            <TableRow key={index}>
                                {columns.map((column) => (
                                    <TableCell
                                        style={{ fontFamily: 'Poppins', fontSize: 12, color: 'black' }}
                                        key={column.key}>
                                        {column.render ? column.render(row[column.dataIndex], row) : row[column.dataIndex]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default DataTable;
